import { render, staticRenderFns } from "./DashboardSkg.vue?vue&type=template&id=34b756a8&scoped=true&"
import script from "./DashboardSkg.vue?vue&type=script&lang=js&"
export * from "./DashboardSkg.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSkg.vue?vue&type=style&index=0&id=34b756a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b756a8",
  null
  
)

export default component.exports